import { useTiclickTableContext } from '@src/design-system/molecules/ticlick-table/context/ticlick-table-context-hook';
import { TABLES_KEYS } from '@shared/constants/tables-keys';

/** None is the default on the leads table. Set `withNoneOption: false` to omit it. */
export function useShowsNoneOption(withNoneOption?: boolean) {
  const { table } = useTiclickTableContext();
  const isLeadsTable =
    table.options.meta?.identifyingData.tableKey === TABLES_KEYS.leadsTable;

  return isLeadsTable && withNoneOption !== false;
}
